import React from 'react';
import PropTypes from "prop-types";
import VideoComponent from "./Video";

import './EmbedVideo.css';
import StalkerApiManager from "../api/StalkerApiLoaderManager";
import EpgItem from "./EpgItem";

let api = StalkerApiManager.getInstance();
let loader = api.getLoader();

class EmbedVideoComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            epg_items: []
        }
    }

    componentDidMount() {
        loader.getEPG(this.props.channel, 1).then(data => {
            this.setState({epg_items: data});
        })
    }

    render() {

        const {channel} = this.props;
        const {epg_items} = this.state;

        return (
            <div className="video-embed-component">
                <VideoComponent channel={channel}></VideoComponent>
                {epg_items && epg_items.length ?
                    <div className="video-embed-component-epg">
                        <div className="video-embed-component-epg-wrapper">
                            <EpgItem disableTime={true} item={epg_items[0]}/>
                        </div>
                    </div>
                    : null
                }
            </div>
        )
    }

}

EmbedVideoComponent.propTypes = {
    channel: PropTypes.object
};

export default EmbedVideoComponent;


// WEBPACK FOOTER //
// ./src/components/EmbedVideo.js